import React from 'react';
import { NavLink } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { NavigationItem, Divisor } from './Navigation.styled';

interface INavigationItem {
    currentRoute: string;
    path: string;
    isHighlighted: (route: string) => boolean;
    icon: any;
    menuItemDescription: string;
    isCollapsed?: boolean;
}

const MenuItem = ({ menuItemDescription, currentRoute, isHighlighted, icon, path, isCollapsed }: INavigationItem) => {
    const highlighted = isHighlighted(currentRoute);

    const itemContent = (
        <NavigationItem isHighlighted={highlighted} id={menuItemDescription} $isCollapsed={isCollapsed}>
            <NavLink
                to={path}
                style={{
                    color: "white",
                    fontSize: 14,
                    width: "100%",
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Divisor $isCollapsed={isCollapsed}>
                    <img 
                        style={{ 
                            width: 20, 
                            height: 20, 
                            minWidth: 20,
                            paddingLeft: isCollapsed ? 0 : "4px" 
                        }} 
                        src={icon} 
                        alt="" 
                    />
                    {!isCollapsed && (
                        <p style={{ 
                            paddingLeft: "14px", 
                            margin: 0,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "0.875rem",
                            fontWeight: highlighted ? 600 : 400
                        }}>
                            {menuItemDescription}
                        </p>
                    )}
                </Divisor>
            </NavLink>
        </NavigationItem>
    );

    if (isCollapsed) {
        return (
            <Tooltip title={menuItemDescription} placement="right" arrow>
                <div>
                    {itemContent}
                </div>
            </Tooltip>
        );
    }

    return itemContent;
};

export default MenuItem;